<template>
  <teksten />
</template>

<script>
import Teksten from '../components/OpbouwPlechtigheid/Teksten.vue'

export default {
  name: 'TekstenView',
  components: {
    Teksten
  }
}
</script>
